// extracted by mini-css-extract-plugin
export default {"Callout":"Callout_Callout__Xufip","CalloutHeader":"Callout_CalloutHeader__SzG1c","CalloutGraphic":"Callout_CalloutGraphic__j7rYr"};